<div class="rx-card print-context read-only scan-options">
    <div class="rx-card-title-print additional-scans">
		<strong>{{ 'ScanOptions.AdditionalScansTitle' | translate }}</strong>
    </div>
	<div class="rx-card-body print-context">
		<div [ngClass]="!!rx?.EmergenceProfile ? 'three-columns' : 'two-columns'"
			name="preTreatmentScan"
			class="checkbox-container">
			<img class="general-info-checkbox-print"
				 [src]="rx?.PrePrepScan | mapper : getSrcForRadioButtonImg.bind(this)"
				 alt="preTreatmentScan"
			>
			<a class="field-name">{{ 'GeneralRxData.PreTreatmentScan' | translate }}</a>
		</div>
		<div class="three-columns checkbox-container" *ngIf="rx?.EmergenceProfile"
			name="emergenceProfile">
			<img class="general-info-checkbox-print"
				 [src]="rx?.EmergenceProfile | mapper : getSrcForRadioButtonImg.bind(this)"
				 alt="emergencyProfile"
			>
			<a class="field-name">{{ 'ScanOptions.EmergenceProfile' | translate }}</a>
		</div>
		<div [ngClass]="!!rx?.EmergenceProfile ? 'three-columns' : 'two-columns'"
			name="dentureCopyScan"
			class="checkbox-container">
			<img class="general-info-checkbox-print"
				 [src]="rx?.DentureDetails?.IsDentureCopyScan | mapper : getSrcForRadioButtonImg.bind(this)"
				 alt="dentureCopyScan"
			>
			<a class="field-name">{{ 'ScanOptions.DentureCopyScan' | translate }}</a>
		</div>
	</div>
	<div class="additional-bites print-container" *ngIf="(isRestoMultiBiteSelected())">
		<div class="rx-card-title-print">
			<strong class="resto-multi-bite-title"> {{ 'ScanOptions.MultiBite' | translate }} </strong>
		</div>
		<div class = "rx-card-body print-context">
			<div class="additional-bites-row rx-app-flex rx-app-flex-container-row">
				<div class="additional-bite"  *ngFor="let bite of additionalBites" [id]= "bite.textKey.toLowerCase()">
					<div class="additional-bite-checkbox-print">
						<img class="general-info-checkbox-print"
							[src]="isBiteSelected(bite.id) | mapper : getSrcForRadioButtonImg.bind(this)"
							alt="additionalBite">
						<a class="field-name">{{ 'RestoMultiBite.' + bite.textKey | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
